import GrubHub from '../../../images/GrubHub.png';

export const GrubHubIcon = () => (
  <div className="order-res-links-icon">
    <img src={GrubHub} alt="Grubhub" />
  </div>
);

export default GrubHubIcon;
